module.exports = __webpack_public_path__ + "img/mode2_icon.d00126b4.png";